import CryptoJS from 'crypto-js'
const { AES, mode, enc } = CryptoJS;

//和后端保持一至
const iv = CryptoJS.enc.Utf8.parse('1234567812345678');
// 加密
function a_encrypt(text,key){
  if (!text){
    return ''
  }
  if(typeof text === 'object'){
    text = JSON.stringify(text)
  }
  //用随机生成的数来作为密码加密
  // key = '1111111111111111';
  key= CryptoJS.enc.Utf8.parse(key);
  text = CryptoJS.enc.Utf8.parse(text);
  return AES.encrypt(text, key, { // 需要和服务端保持一致
    iv: iv,
    mode: mode.CBC,
    padding : CryptoJS.pad.ZeroPadding
  }).toString();
}

// 解密
function a_decrypt(ciphertext,aesKey){ //这个key为后端传过来的key(经过rsa解密)
  let key=enc.Utf8.parse(aesKey);
  const text = AES.decrypt(ciphertext, key,{ // 需要和服务端保持一致
    iv: iv,
    mode: mode.CBC,
    padding : CryptoJS.pad.ZeroPadding}).toString(enc.Utf8);
  let data = null
  try {
    data = JSON.parse(text)
  } catch (error) {
    data = text
  }
  return data
}

export { a_encrypt, a_decrypt }
export default CryptoJS



// WEBPACK FOOTER //
// ./src/modules/utils/crypto.js